export default "/kiban/_next/static/images/1ClickHeaderLogo-0247ad700c8ba9ec9030dbae93bf0c4a.png";